import styled from 'styled-components';

export const TopDomains = styled.div`
  @media (max-width: 1702px) {
    margin-top: 0.5em;
    min-width: 100%;
    margin-bottom: 0.5em;
  }

  iframe {
    border: unset;
    min-height: 41em;
  }
`;
